import { getDomainSource, SERVICE } from '@musinsa/packages-device-detection';

/**
 * 로그인 페이지 URL을 생성합니다.
 *
 * @param redirectUri - 로그인 후 돌아올 URL (기본값: 현재 페이지)
 * @returns 로그인 페이지 URL
 */
export const createLoginUrl = (redirectUri?: string): string => {
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  const service = getDomainSource(window.location.hostname);
  const uri = redirectUri || currentUrl;

  return service === SERVICE.MUSINSA
    ? `${process.env.NEXT_PUBLIC_MUSINSA_BASE_URL}/auth/login?referer=${encodeURIComponent(uri)}`
    : `${process.env.NEXT_PUBLIC_29CM_AUTH_URL}/login?redirect_uri=${encodeURIComponent(uri)}`;
};
